import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaShieldAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Version.css"; // Reusing the high-end layout
import IntegrationReport from './IntegrationReport';

function Privacy() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="version-page">
      <nav className="navbar">
        <div className="logo-container">
          <Link to="/" className="back-link">
            <FaArrowLeft /> Home
          </Link>
          <h2 className="logo" style={{marginLeft: '20px'}}>🇮🇳 Bharat Connect</h2>
        </div>
      </nav>

      <div className="version-container">
        <div style={{textAlign: 'center', marginBottom: '40px'}}>
          <FaShieldAlt style={{fontSize: '3rem', color: '#00a884', marginBottom: '20px'}} />
          <h1 data-aos="fade-down">Privacy Policy</h1>
          <div className="version-tag" style={{display: 'inline-block', marginBottom: '10px'}}>v1.0.1 Official</div>
          <p className="version-subtitle" data-aos="fade-down" data-aos-delay="100">
            Last Updated: March 24, 2026
          </p>
        </div>

        <div className="timeline">
          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>1. Information We Collect</h3>
              <p>Bharat Connect adheres to the principle of "Data Minimization". We only collect what is necessary:</p>
              <ul>
                <li><strong>Account Metadata:</strong> Email, Display Name, and optionally Phone Numbers for 2FA.</li>
                <li><strong>Encrypted Payload:</strong> Chat messages are stored as 256-bit AES encrypted blobs. We cannot read the content.</li>
                <li><strong>Network Logs:</strong> IP addresses and device identifiers for security auditing and DDoS prevention.</li>
              </ul>
            </div>
          </div>

          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>2. Data Retention & Deletion</h3>
              <p>We retain your data only as long as your account is active:</p>
              <ul>
                <li><strong>Active Storage:</strong> Messages remain accessible as long as the account exists.</li>
                <li><strong>Right to Erasure:</strong> Upon account deletion, all associated data is purged from our production databases within 30 days.</li>
                <li><strong>Backups:</strong> Encrypted backups are maintained for 90 days for disaster recovery purposes.</li>
              </ul>
            </div>
          </div>

          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>3. Your Rights & Control</h3>
              <p>Under Indian Data Protection standards, you have the right to:</p>
              <ul>
                <li>Access a copy of your personal data stored on our servers.</li>
                <li>Rectify inaccurate information in your profile.</li>
                <li>Withdraw consent for data processing by deleting your account.</li>
              </ul>
            </div>
          </div>

          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>5. Cookie & Session Policy</h3>
              <p>We use local storage and secure cookies to manage your active chat sessions and theme preferences. No tracking pixels from third-party advertisers are ever deployed.</p>
            </div>
          </div>

          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>6. Policy Updates</h3>
              <p>Bharat Connect reserves the right to modify this policy. Significant architectural changes affecting your privacy will be notified via the platform dashboard.</p>
            </div>
          </div>
        </div>
      </div>
      <IntegrationReport />
    </div>
  );
}

export default Privacy;
